export default __webpack_public_path__ + "static/media/Left_arrow.3dfaf960.svg";